/** The pager: which rows of how many, and the way to the next page. Shown only when there is more than one page. */
import React from 'react';

export default function Pager({ page, limit, total, onPage, label = 'rows' }: { page: number; limit: number; total: number; onPage: (p: number) => void; label?: string }) {
  const pages = Math.max(1, Math.ceil(total / limit));
  if (total <= limit && page <= 1) return null;
  const from = total === 0 ? 0 : (page - 1) * limit + 1;
  const to = Math.min(page * limit, total);
  return (
    <nav className="board-pager" aria-label="Pages">
      <span className="board-pager__where" aria-live="polite">
        {page > pages
          ? `Page ${page} is past the end · ${total.toLocaleString('en-US')} ${label} on ${pages} ${pages === 1 ? 'page' : 'pages'}`
          : `${from.toLocaleString('en-US')}–${to.toLocaleString('en-US')} of ${total.toLocaleString('en-US')} ${label} · page ${page} of ${pages}`}
      </span>
      <span className="board-pager__btns">
        <button type="button" className="board-btn" onClick={() => onPage(page - 1)} disabled={page <= 1}>Previous</button>
        <button type="button" className="board-btn" onClick={() => onPage(page + 1)} disabled={page >= pages}>Next</button>
      </span>
    </nav>
  );
}
